import { OrdersState } from 'store/ordersStore/reducer';
import { UserState } from 'store/userStore/reducer';

type OrdersLoadState = Pick<OrdersState, 'isOrdersListSettled' | 'orders' | 'orderDetails'>;
type UserLoadState = Pick<
    UserState,
    'restaurants' | 'currentRestaurantId' | 'areRestaurantsSettled'
>;

export function isOrdersListLoading(orders: OrdersLoadState, user: UserLoadState): boolean {
    const hasPosition = !!user.restaurants.find((x) => x.id === user.currentRestaurantId)
        ?.currentPosition;
    return !orders.isOrdersListSettled && (hasPosition || !user.areRestaurantsSettled);
}

export function isOrderDetailsLoading(
    orders: OrdersLoadState,
    user: UserLoadState,
    isDetailsLoadFailed: boolean
): boolean {
    if (isOrdersListLoading(orders, user)) {
        return true;
    }
    return orders.orders.length > 0 && !orders.orderDetails.id && !isDetailsLoadFailed;
}
